import React from 'react';
import ChooseRole from 'app/ui/components/choose-role/ChooseRole';


export default function RegisterPage() {
  return (
    <ChooseRole
      clientRegisterLink="/visitor/client-enroll/care-type"
      heroRegisterLink="/hero/onboarding/step1"
      headingSectionOverTitle="Register as a"
      showAlreadyHaveAccount={true}
    />
  );
}
